<template>
    <div class="widget" v-bind:class="[{'loaded':loaded},className]">

        <header class="widget-header">
            <h2 class="widget-title">{{ title }}</h2>
            <h3 class="widget-title-period">
                <span v-for="item in periods" v-if="item.id == period">{{ item.label }}</span>
            </h3>

            <div class="widget-actions-container">
            <widget-dropdown v-model="period" :options="periods" :callback="filterByPeriod"></widget-dropdown>
            </div>

        </header>

        <div class="widget-preloader">
            <div class="pre-loader">
                <div class="box1"></div>
                <div class="box2"></div>
                <div class="box3"></div>
                <div class="box4"></div>
                <div class="box5"></div>
            </div>
        </div>

        <div class="widget-content" v-if="stats.dataset">

            <div class="widget-content-datas">
                <div class="data-labels">

                  <div class="data-label">
                    <strong>{{ count }}</strong>
                    <span class="compare-to-previous">
                      <compare :previous="count_last" :current="count"></compare>
                    </span>
                    <span class="legend">Total usage</span>
                  </div>

                  <div class="data-label">
                    <strong><i class="currency">{{ currency }}<span>TTC</span></i> {{ total|formatNumber }}</strong>
                    <span class="compare-to-previous">
                      <compare :previous="total_last" :current="total"></compare>
                    </span>
                    <span class="legend">Total des coûts</span>
                  </div>

              </div>
            </div>

            <div class="widget-chart" v-bind:class="{'active':stats.labels.length}">
                <chart :dataset="stats.dataset" :labels="stats.labels" :options="options" v-if="stats && stats.labels.length"></chart>
            </div>

        </div>
        <!--
        <div class="buttons">
            <router-link to="/person"><span>Voir la liste</span></router-link>
        </div>
        -->
    </div>
</template>
<script>

    import ScopeService from './ScopeService.js';
    import Chart from '../../components/chart/Spline.vue'

    export default {
        name: 'Widget',
        components: {
            'chart' : Chart
        },
        props: ['title','period','provider','className'],
        data () {
            return {
                periods: [
                    {id: 'last_7days', label: '7 derniers jours'},
                    {id: 'current_month', label: 'Ce mois'},
                    {id: 'last_month', label: 'Le mois dernier'},
                    {id: 'since_1_month', label: '30 derniers jours'},
                    {id: 'since_3_months', label: '90 derniers jours'},
                    {id: 'current_year', label: 'Cette année'},
                    {id: 'last_year', label: 'Depuis 12 mois'},
                    {id: 'all', label: 'Tout'},
                ],
                loaded: false,
                stats: {
                    dataset: null,
                    labels: null
                },
                count: null,
                count_last: null,
                total: null,
                total_last: null,
                options: {
                    layout: {
                        padding: {
                            left: 0,
                            right: 10,
                            top: 0,
                            bottom: 0
                        }
                    },
                    scales: {
                        xAxes: [ {
                            categoryPercentage: 0.9,
                            barPercentage: 0.9,
                            stacked: false,
                            steppedLine: true,
                            gridLines: {
                                offsetGridLines: false,
                                display: false,
                                color: "#dddddd",
                                drawBorder: false
                            },
                            ticks: {
                                display: true,
                                fontColor: "#aaaaaa",
                                fontSize: 12,
                            },
                        }],
                        yAxes: [ {
                            stacked: false,
                            steppedLine: true,
                            gridLines: {
                                offsetGridLines: true,
                                display: true,
                                color: "#dddddd",
                                borderDashOffset: 1,
                                borderDash: [2,2],
                                drawBorder: false
                            },
                            ticks: {
                                fontColor: "#aaaaaa",
                                fontSize: 12,
                                display: true,
                                padding: 0,
                                suggestedMin: 0
                            }
                        }]
                    }
                }
            }
        },
        mounted: function(){
            this.currency = this.$store.state.scope.currency_id
            this.period = this.period ? this.period : this.periods[0].id

            this.filterByPeriod(this.period);

        },
        methods: {
            filterByPeriod: function(period)
            {
                this.loaded = false;

                this.period = period

                ScopeService.getNotificationSent( period, this.provider ).then((response) => {
                    this.stats.dataset = response.data.stats.dataset
                    this.stats.labels = response.data.stats.labels
                    this.total = response.data.total
                    this.total_last = response.data.total_last
                    this.count = response.data.count
                    this.count_last = response.data.count_last

                    this.loaded = true;
                }).catch((response) => {
                    console.log("error", response);
                    this.loaded = true;
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/scope/ScopeWidget.vue